<template>
    <div class="bg-white">
        <Head>
            <title>Озера</title>
        </Head>
        <Header pageName="Озера" :lakes="lakes" :cart-count="cartCount"/>
        <flash-message :message="flash.error" />
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <div>
                <h2 class="page-title">Наші Озера</h2>
            </div>
            <div class="my-4">
                <p class="my-4 leading-7">Ми пропонуємо декілька чудових озер на Ваш вибір, де всі рибалки та любителі природи можуть насолодитися мальовничими краєвидами, чистою водою та свіжим повітрям.</p>
                <p class="my-4 leading-7">Наші водойми пишаються своїм різноманіттям риби, яке гарантує чудові улови та незабутні враження від вашого улюбленого заняття.</p>
            </div>
            <div class="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 xl:gap-x-8">
                <Link :href="`/lake/${lake.id}`" class="group" v-for="lake in lakes">
                    <div
                        class="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                        <img :src="`/storage/${lake.images}`"
                             :alt=lake.name
                             class="h-full w-full object-cover object-center group-hover:opacity-75">
                    </div>
                    <p class="mt-1 text-xl font-bold text-gray-900">{{ lake.name }}</p>
                    <p class="mt-1 text-s font-medium text-gray-900" v-html="lake.short_description" />
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Header from "@/Component/Header"
import { Link } from '@inertiajs/inertia-vue3'
import FlashMessage from '@/Component/FlashMessage'

export default {
    components: {
        Header,
        Head,
        Link,
        FlashMessage
    },
    props: {
        lakes: {
            type: Array,
            default: []
        },
        cartCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            flash: this.$page.props.flash || {}
        }
    }
}
</script>
